import { get, post, put } from '../index'

export default {
  get: (array) => get('settings', {
    select: array
  }),
  update: (setting, value) => put('settings', value),
  erp: {
    get: () => get(`settings/erp`),
    create: (body) => post(`settings/erp`, body)
  }
}
